import React from "react";

const LoadMoreButton = ({ loadMore, buttonText = "Show more" }) => {
  return (
    <button
      type="button"
      onClick={loadMore}
      style={{
        display: "block",
        margin: "2rem auto 0 auto",
        paddingLeft: "0",
        outline: "none",
        fontSize: "2.6rem",
        fontStyle: "italic",
        backgroundColor: "transparent",
        border: "none",
        color: "black",
      }}
    >
      {buttonText}
    </button>
  );
};

export default LoadMoreButton;
